import { Box, Button } from "@mui/material";
// Modern Toggle Component
const ModernToggle = ({ leftLabel, rightLabel, checked, onChange, size = "medium" }) => {
    const fontSize = size === "small" ? "0.75rem" : "0.875rem";
    const padding = size === "small" ? "6px 12px" : "8px 16px";

    return (
        <Box
            sx={{
                display: "inline-flex",
                backgroundColor: "#f5f5f5",
                borderRadius: 2,
                p: 0.5,
                border: "1px solid #e0e0e0",
                fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
            }}
        >
            <Button
                onClick={() => onChange(false)}
                sx={{
                    px: size === "small" ? 1.5 : 2,
                    py: size === "small" ? 0.75 : 1,
                    borderRadius: 1.5,
                    fontSize: fontSize,
                    fontWeight: 500,
                    textTransform: "none",
                    minWidth: "auto",
                    backgroundColor: !checked ? "#ffffff" : "transparent",
                    color: !checked ? "#1976d2" : "#666666",
                    border: !checked ? "2px solid #1976d2" : "2px solid transparent",
                    boxShadow: !checked ? "0 2px 4px rgba(25, 118, 210, 0.2)" : "none",
                    "&:hover": {
                        backgroundColor: !checked ? "#f8f9ff" : "rgba(0, 0, 0, 0.04)",
                        borderColor: !checked ? "#1565c0" : "transparent",
                    },
                    transition: "all 0.2s ease-in-out",
                }}
            >
                {leftLabel}
            </Button>
            <Button
                onClick={() => onChange(true)}
                sx={{
                    px: size === "small" ? 1.5 : 2,
                    py: size === "small" ? 0.75 : 1,
                    borderRadius: 1.5,
                    fontSize: fontSize,
                    fontWeight: 500,
                    textTransform: "none",
                    minWidth: "auto",
                    backgroundColor: checked ? "#ffffff" : "transparent",
                    color: checked ? "#1976d2" : "#666666",
                    border: checked ? "2px solid #1976d2" : "2px solid transparent",
                    boxShadow: checked ? "0 2px 4px rgba(25, 118, 210, 0.2)" : "none",
                    "&:hover": {
                        backgroundColor: checked ? "#f8f9ff" : "rgba(0, 0, 0, 0.04)",
                        borderColor: checked ? "#1565c0" : "transparent",
                    },
                    transition: "all 0.2s ease-in-out",
                }}
            >
                {rightLabel}
            </Button>
        </Box>
    );
};
export default ModernToggle;